import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1725e9bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin":"10px 0 5px 0"} }, "Схемы погрузки", -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "schemes" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "schemeInfoBlock" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "schemeInfoBlock" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Грузы:", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "schemeInfoBlock" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Смещение ЦТ:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Продольное ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" мм ")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" (допуск ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" мм) ")
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" , ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" кг ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" . Поперечное ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" мм ")
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" (допуск ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" мм) ")
const _hoisted_37 = { key: 3 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" , ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" кг ")
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["src"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["src"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_PlanTransportGroupResultLoadingSchemeJournal = _resolveComponent("PlanTransportGroupResultLoadingSchemeJournal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DxLoadPanel, {
        visible: _ctx.loading,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
        "show-indicator": true,
        "show-pane": true,
        shading: false,
        "close-on-outside-click": false
      }, null, 8, ["visible"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PlanTransportGroupResultLoadingSchemeJournal, {
          onContentReady: _ctx.onContentReady,
          onSelectionChanged: _ctx.onSelectionChanged,
          parentModel: _ctx.parentModel,
          parentEditingConfig: _ctx.parentEditingConfig
        }, null, 8, ["onContentReady", "onSelectionChanged", "parentModel", "parentEditingConfig"])
      ]),
      _createElementVNode("div", {
        id: _ctx.loadingSchemeDomId,
        class: "scheme-info",
        style: {"background":"white"}
      }, [
        (_ctx.model.scheme)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h5", null, " Схема погрузки №" + _toDisplayString(_ctx.model.number) + " в ТС \"" + _toDisplayString(_ctx.model.transport.name) + "\" ", 1),
                    _createElementVNode("p", _hoisted_8, [
                      _createElementVNode("strong", null, "Заказ: " + _toDisplayString(_ctx.model.scheme.orderDescription), 1),
                      _hoisted_9,
                      _createElementVNode("strong", null, "Количество: " + _toDisplayString(_ctx.model.scheme.count), 1),
                      _hoisted_10,
                      _createElementVNode("span", null, " Грузоподъемность (кг): " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.scheme.calcLoadCapacity
                    )), 1),
                      (_ctx.model.transport.transportType === 2)
                        ? (_openBlock(), _createElementBlock("br", _hoisted_11))
                        : _createCommentVNode("", true),
                      (_ctx.model.transport.transportType === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Нагрузка (ось тягача) (кг): " + _toDisplayString(Intl.NumberFormat("ru-RU").format(_ctx.model.scheme.tractorLoad)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.model.transport.transportType === 2)
                        ? (_openBlock(), _createElementBlock("br", _hoisted_13))
                        : _createCommentVNode("", true),
                      (_ctx.model.transport.transportType === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Нагрузка (ось прицепа) (кг): " + _toDisplayString(Intl.NumberFormat("ru-RU").format(_ctx.model.scheme.trailerLoad)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_15, [
                      _hoisted_16,
                      _hoisted_17,
                      _hoisted_18,
                      _createElementVNode("span", {
                        style: {"word-wrap":"normal"},
                        class: "cargoes",
                        innerHTML: _ctx.cargoes
                      }, null, 8, _hoisted_19),
                      _hoisted_20,
                      _createElementVNode("span", null, " Вес груза (кг): " + _toDisplayString(Intl.NumberFormat("ru-RU").format(_ctx.model.scheme.weight)) + " (" + _toDisplayString(_ctx.model.transportLoadCapacityPercent) + "%) ", 1)
                    ]),
                    _createElementVNode("p", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      _createElementVNode("span", null, [
                        _hoisted_24,
                        _createElementVNode("b", null, _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      Math.abs(_ctx.model.scheme.centerMassLongitudinalDisplacement)
                    )), 1),
                        _hoisted_25,
                        _createElementVNode("b", null, _toDisplayString(_ctx.model.scheme.centerMassLongitudinalDisplacementDirection), 1),
                        (_ctx.model.transport.transportType !== 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("b", null, _toDisplayString(Intl.NumberFormat("ru-RU").format(
                        _ctx.model.scheme.permissibleLongitudinalDisplacement
                      )), 1),
                              _hoisted_28
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.model.transport.transportType == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("b", null, _toDisplayString(Intl.NumberFormat("ru-RU").format(
                          _ctx.model.scheme.cargoWeightDifferenceByHalfLength
                        )), 1),
                              _hoisted_31
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_32,
                        _createElementVNode("b", null, _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      Math.abs(_ctx.model.scheme.centerMassTransverseDisplacement)
                    )), 1),
                        _hoisted_33,
                        _createElementVNode("b", null, _toDisplayString(_ctx.model.scheme.centerMassTransverseDisplacementDirection), 1),
                        (_ctx.model.transport.transportType !== 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("b", null, _toDisplayString(Intl.NumberFormat("ru-RU").format(
                          _ctx.model.scheme.permissibleTransverseDisplacement
                        )), 1),
                              _hoisted_36
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.model.transport.transportType == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                              _hoisted_38,
                              _createElementVNode("b", null, _toDisplayString(Intl.NumberFormat("ru-RU").format(
                          _ctx.model.scheme.cargoWeightDifferenceByHalfWidth
                        )), 1),
                              _hoisted_39
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  (_ctx.showSchemeFromVehicleBack)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("img", {
                          style: {"max-height":"100%","max-width":"100%"},
                          src: `data:image/png;base64, ${_ctx.model.endViewScheme}`
                        }, null, 8, _hoisted_43)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.topViewSchemes, (topViewScheme, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (_ctx.showSchemeLevels && _ctx.model.topViewSchemes.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("strong", null, "Вид сверху. Ярус № " + _toDisplayString(index + 1), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          style: {"max-height":"100%","max-width":"100%"},
                          src: `data:image/png;base64, ${topViewScheme}`
                        }, null, 8, _hoisted_45)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.showSchemeCuts)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.verticalCutSchemes, (verticalCutScheme, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("strong", null, "Вид сбоку. Разрез № " + _toDisplayString(index + 1) + "-" + _toDisplayString(index + 1), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                style: {"max-height":"100%","max-width":"100%"},
                                src: `data:image/png;base64, ${verticalCutScheme}`
                              }, null, 8, _hoisted_47)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_4)
    ])
  ], 64))
}